/* eslint-disable */
import Vue from 'vue'

// Lib imports
import axios from 'axios'
import store from '@/store/store'

var instance = axios.create({
    baseURL: AppConfig.vssapiurl
})

instance.interceptors.request.use(async config => {
    store.commit('app/setHttpRunning', true)
    if (Vue.prototype.$auth.isAuthenticated) {
        const token = await Vue.prototype.$auth.getTokenSilently()
        config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
    store.commit('app/setHttpRunning', false)
    store.commit('app/clearErrors')
    return response
}, function (error) {
    store.commit('app/setHttpRunning', false)
    var errorObject = {
        //id: _.uniqueId('error_'),
        //time: dateService.toStringNow(),
        //url: error.config.url.replace(error.config.baseURL, ''),
        status: error.response ? error.response.status + ' - ' : '',
        message: error.message,
        stack: error.stack
    }
    store.commit('app/addError', errorObject)
    return Promise.reject(error)
})

Vue.prototype.$http = instance
Vue.prototype.$httpRunning = false
